import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Container, Row } from "react-bootstrap";
//Services
import api from "../../../service/api";
//Components
import Header from "../../../components/Header";
import Table from "../../../components/Table";
import Main from "../../../components/Main/index";
import SideContainerAnimated from "../../../components/SideContainer";
import SideForm from "../../../components/SideForm";
import Input from "../../../components/Input/index";
import Button from "../../../components/Button/index";
import DropdownButton from "../../../components/DropdownButton";
import Modal from "../../../components/ModalSuccessMessage";
import NavTabs from "../../../components/NavTabs";
import Select from "../../../components/Select";
import ErrorMessage from "../../../components/ErrorMessage";
import Animation from "../../../components/Animation/animation";
//Styles
import { 
  Legend, 
  THead, 
  Th, 
  ThFilterable, 
  Td, 
  RadioButtonRow, 
  RadioButtonForm, 
  RadioButtonContainer, 
  RadioButtonContent, 
  RadioButtonDescription 
} from "./styles";
//Routes
import routes from "../../../routes/users.routes";
//Action Functions
import { ownerBranchs } from "../../../redux/actions/branchs";
//Help Functions
import { openModal } from "../../../helpers/modalFunctions";
//Assets
import Person from "../../../assets/icons/manHover.svg";
import upArrow from "../../../assets/icons/chevron-up.svg";
import downArrow from "../../../assets/icons/chevron-down.svg";
//Interfaces
import { GroupListInterface, UserListInterface, ValuesForm } from "./interfaces";

const General = () => {
  const [isAddFormVisible, setIsAddFormVisible] = useState(false);
  const [isEditFormVisible, setIsEditFormVisible] = useState(false);

  const [userList, setUserList] = useState<Array<any>>([]);
  const [selectedUser, setSelectedUser] = useState<any>({});

  const [groupList, setGroupList] = useState<Array<any>>([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [establishmentType, setEstablishmentType] = useState(0);
  const [establishmentList, setEstablishmentList] = useState<Array<any>>([]);
  const [selectedEstablishment, setSelectedEstablishment] = useState<any>({})

  const [maxPage, setMaxPage] = useState(1);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const [errorOnSubmit, setErrorOnSubmit] = useState(false);

  const login = useSelector((state: {login: any}) => state.login);
  const owner = useSelector((state: {branchs: any}) => state.branchs);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if(login.user.groups.am2a1){
      history.push("/admin/dashboard");
    }
  }, []);

  useEffect(() => {
    const getGroupListFromAPI = async () => {
      const { data } = await api.get("adm/group");

      setGroupList(data);
    }

    getGroupListFromAPI();
  }, []);
  
  useEffect(() => {
    const getUserListFromAPI = async () => {
      try {
        const { data } = await api.get("/adm/owner100pay/list", {
          params: {
            page,
            users: login.user.owners.id
          }
        });
        const newUserList: Array<any> = [...data.Response[0]["User Branch"], ...data.Response[0]["User Owner"]];
        
        setUserList(newUserList);
        setMaxPage(data.pageCount);
        setIsLoading(false)
      } catch (error) {
        
      }
      
    } 

    setIsDataLoaded(false);
    getUserListFromAPI();
    setIsDataLoaded(true);
  }, [page]);

  useEffect(() => {
    const getEstablishmentsAccordingToType = async () => {
      if(establishmentType === 0){
        if(owner.branchs.length === 0){
          const { data } = await api.get("/adm/owner100pay/list", {
            params: {
              id: login.user.owners.id
            }
          });

          setEstablishmentList(data.Branch);
          dispatch(ownerBranchs(data.Branch));
          setSelectedEstablishment(data.Branch[0].id);
        }
        
        else {

          setEstablishmentList(owner.branchs);
          setSelectedEstablishment(owner.branchs[0].id);
        }
      }
      
      else {
        const { data } = await api.get("/adm/owner100pay/list");

        setEstablishmentList(data);
        setSelectedEstablishment(data[0].id);
      }

    }

    getEstablishmentsAccordingToType();
  }, [establishmentType]);

  const openAddForm = () => {
    if (isEditFormVisible !== true) {
      setIsAddFormVisible(true);
    }
  };

  const openEditForm = (user: any) => {
    if (isAddFormVisible !== true) {
      setIsEditFormVisible(true);
    }
  };

  const handleSelectedUser = (user: any) => {
    console.log(user)
    setSelectedEstablishment(user.us_branchsId);
    setSelectedUser(user);
  }

  const tableContentGenerator = () => {
    if(userList.length !== 0){
      return userList.map((user: UserListInterface, index) => (
        <tr key={index} style={{ height: 67 }}>
          <Td>{user.us_id}</Td>
          <Td>{user.us_name}</Td>
          <Td>{user.gp_type || user.gp_description}</Td>
          <Td>{user.us_email}</Td>
          <Td>{user.us_IsActive ? "ATIVO": "Inativo"}</Td>
          <Td>
            <DropdownButton 
              isEditOptionVisible={true} 
              setIsEditFormVisible={openEditForm} 
              selectedUser={user} 
              setSelectedUser={handleSelectedUser}
            />
          </Td>
        </tr>
      ));

    }
  };

  const groupOptionsDefiner = () => {
    if(groupList.length > 0){
      return groupList.map((group: GroupListInterface) => {
        return <option key={group.id} value={group.id}>{group.description}</option>
      })
    }
  }

  const branchsOptionsDefiner = () => {
    return establishmentList.map(branch => {
      return <option key={branch.id} value={branch.id}>{businessNameReducerLength(branch.businessName)}</option>
    })
  }

  const businessNameReducerLength = (businessName: string) => {
    if(businessName.length > 35){
      return `${businessName.slice(0, 34).toUpperCase()}...`
    } else {
      return businessName.toUpperCase()
    }
  }

  const FormValidationWithYup = Yup.object().shape({
    name: Yup.string().required("Required"),
    email: Yup.string().email().required("Required"),
    password: Yup.string().min(6).required("Required"),
    passwordConfirmed: Yup.string().min(6).required("Required"),
    group: Yup.string().required("Required"),
    status: Yup.string().required("Required"),
    seller: Yup.string().required("Required"),
  })

  const numForActive = 1;
  const numForInactive = 0;

  const openForm = isAddFormVisible || isEditFormVisible;

  return (
    <Container fluid >
      <Row>
        <Modal text="Adicionado com Sucesso" />
        <Main
          className={` ${openForm ? "col-d-none column-side-open" : "column-content"}`}
          isFormVisible={isAddFormVisible}
        >
          <Header
            title="Usuários"
            subTitle="Gerencie todos os usuários do sistema"
            subTitleWidth={174}
          />

          <NavTabs tabs={routes}/>

          <Table
            buttonText="Adicionar Usuário"
            isAddFormVisible={isAddFormVisible}
            setIsAddFormVisible={openAddForm}
            showAddButton={true} //login.user.groups.am2a1c
            showExportButton={true}  //login.user.groups.am2a1e
            maximumPage={maxPage}
            page={page}
            setPage={setPage}
          >
            <THead>
              <tr>
                <Th>
                    <ThFilterable>
                    <div>ID</div>
                    <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                        <img src={upArrow} alt="seta para cima" />
                        <br />
                        <img src={downArrow} alt="seta para baixo" />
                    </div>
                    </ThFilterable>
                </Th>
                <Th>Nome</Th>
                <Th>Grupo</Th>
                {/* <Th>Vendedor</Th> */}
                <Th>Email</Th>
                <Th>
                    <ThFilterable>
                    <div>Status</div>
                    <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                        <img src={upArrow} alt="seta para cima" />
                        <br />
                        <img src={downArrow} alt="seta para baixo" />
                    </div>
                    </ThFilterable>
                </Th>
                <Th></Th>
              </tr>
            </THead>
              {isDataLoaded 
                ? isLoading 
                  ? <Animation/>
                  : <tbody>
                    { tableContentGenerator() }
                  </tbody> 
              : null}
          </Table>
        </Main>

        <SideContainerAnimated isVisible={isAddFormVisible}>
          <SideForm
            title="Adicionar Usuário"
            icon={Person}
            visible={() => setIsAddFormVisible(false)}
          >
            <Formik
              initialValues={{
                name: "",
                email: "",
                password: "",
                passwordConfirmed: "",
                status: numForActive,
                group: groupList[0] === undefined ? "" : groupList[0].id,
                seller: selectedEstablishment?.id,
              }}
              validationSchema={FormValidationWithYup}
              onSubmit={ async (values) => {
                if(values.password === values.passwordConfirmed){
                  if(establishmentType === 0){
                    try {
                      const response = await api.post("/users", {
                        name: values.name,
                        email: values.email,
                        password: values.password,
                        groupsId: {
                          id: values.group
                        },
                        branchsId: {
                          id: values.seller
                        },
                        ownersId: {
                          id: null
                        },
                        isActive: values.status === numForActive ? true : false
                      });
  
                      openModal("exampleModal");
  
                      const { data } = await api.get("/adm/owner100pay/list", {
                        params: {
                          page,
                          users: login.user.owners.id
                        }
                      });
  
                      const newUserList: Array<any> = [...data.Response[0]["User Branch"], ...data.Response[0]["User Owner"]];
                      
                      setUserList(newUserList);
                      setMaxPage(data.pageCount);
                    } catch (error) {
                      setErrorOnSubmit(true);
                    }
                  } else {
                    try {
                      const response = await api.post("/users", {
                        name: values.name,
                        email: values.email,
                        password: values.password,
                        groupsId: {
                          id: values.group
                        },
                        branchsId: {
                          id: null
                        },
                        ownersId: {
                          id: values.seller
                        },
                        isActive: values.status === numForActive ? true : false
                      });
  
                      openModal("exampleModal");
  
                      const { data } = await api.get("/adm/owner100pay/list", {
                        params: {
                          page,
                          users: login.user.owners.id
                        }
                      });
  
                      const newUserList: Array<any> = [...data.Response[0]["User Branch"], ...data.Response[0]["User Owner"]];
                      
                      setUserList(newUserList);
                      setMaxPage(data.pageCount);
                      setErrorOnSubmit(false);
                    } catch (error) {
                      setErrorOnSubmit(true);
                    }
                  }
                } else {
                  setErrorOnSubmit(true);
                }
              }}
            >
              {({ errors, initialValues, values }) => {
                initialValues.group = groupList[0] === undefined ? "" : groupList[0].id;
                values.seller = selectedEstablishment
                
                return(
                  <Form style={{ width: "100%", marginTop: 41 }} id="form">
                    <fieldset>
                      <Legend>Dados Principais</Legend>
                      <Field id="name" name="name" className="inputCustom" placeholder="Nome" as={Input}/>
                      <Field id="email" name="email" className="inputCustom" placeholder="Email" as={Input}/>
                      <Field id="password" name="password" type="password" className="inputCustom" placeholder="Senha" as={Input}/>
                      <Field id="passwordConfirmed" name="passwordConfirmed" type="password" className="inputCustom" placeholder="Confirmar Senha" as={Input}/>
                    </fieldset>
                    <fieldset>
                      <Legend>Acesso</Legend>
                      <Field id="status" name="status" as={Select}>
                          <option value={numForActive}>Ativo</option>
                          <option value={numForInactive}>Inativo</option>
                      </Field>

                      <Field id="group" name="group" as={Select}>
                          { groupOptionsDefiner() }
                      </Field>

                      <RadioButtonRow>
                        <RadioButtonForm onClick={() => {
                          setEstablishmentType(0);  
                        }}>
                            <RadioButtonContainer>
                                <RadioButtonContent isPrimary={establishmentType === 0}/>
                            </RadioButtonContainer>
                            <RadioButtonDescription>Filial</RadioButtonDescription>
                        </RadioButtonForm>

                        <RadioButtonForm onClick={() => {
                          setEstablishmentType(1);
                        }}>
                            <RadioButtonContainer>
                                <RadioButtonContent isPrimary={establishmentType === 1}/>
                            </RadioButtonContainer>
                            <RadioButtonDescription>Matriz</RadioButtonDescription>
                        </RadioButtonForm>
                      </RadioButtonRow>

                      <Field 
                        id="seller" 
                        name="seller" 
                        disabled={establishmentType === 1} 
                        as={Select}
                        onChange={(e: any) => {
                          setSelectedEstablishment(e.target.value);
                        }}
                      >
                        {branchsOptionsDefiner()}
                      </Field>
                    </fieldset>

                    {
                      errorOnSubmit && (
                        <ErrorMessage>
                          Erro ao editar usuário
                        </ErrorMessage>
                      )
                    }

                    <Button
                      type="submit"
                      className="buttonCustom"
                    >
                      Adicionar
                    </Button>
                  </Form>
                )

                
              }}
            </Formik>
          </SideForm>
        </SideContainerAnimated>

        <SideContainerAnimated isVisible={isEditFormVisible}>
          <SideForm
            title="Editar Usuário"
            icon={Person}
            visible={() => setIsEditFormVisible(false)}
          >
            <Formik
              initialValues={{
                name: "",
                email: "",
                password: "",
                passwordConfirmed: "",
                status: numForActive,
                group: groupList[0] === undefined ? "" : groupList[0].id,
                seller: ""
              }}

              onSubmit={async (values) => {
                try {
                  if(values.password.length === 0){
                    const response = await api.put(`user/update?id=${selectedUser.us_id}`, {
                      name: values.name,
                      email: values.email,
                      groupsId:  values.group,
                      powerUser: null,
                      branchsId: establishmentType === 0 ? values.seller : null,
                    });
                  } else if(values.password === values.passwordConfirmed) {
                    const response = await api.put(`user/update?id=${selectedUser.us_id}`, {
                      name: values.name,
                      email: values.email,
                      password: values.password,
                      groupsId:  values.group,
                      branchsId: establishmentType === 0 ? values.seller : null,
                    });
                  } else {
                    setErrorOnSubmit(true)
                  }

                  openModal("exampleModal");

                  const { data } = await api.get("/adm/owner100pay/list", {
                    params: {
                      page,
                      users: login.user.owners.id
                    }
                  });
                  const newUserList: Array<any> = [...data.Response[0]["User Branch"], ...data.Response[0]["User Owner"]];
                  
                  setUserList(newUserList);
                  setMaxPage(data.pageCount);
                  setErrorOnSubmit(false);
                } catch (error) {
                  setErrorOnSubmit(true);
                }
              }}
            >
              {({ values, initialValues, handleChange }) => {
                initialValues.email = selectedUser.us_email;
                initialValues.group = selectedUser.us_groupsId;
                initialValues.name = selectedUser.us_name;
                initialValues.seller = selectedUser.us_branchsId;

                return(
                  <Form style={{ width: "100%", marginTop: 41 }} id="form">

                    <fieldset>
                      <Legend>Cadastro</Legend>
                      <Field id="name" name="name" className="inputCustom" placeholder="Nome" as={Input}/>
                      <Field id="email" name="email" className="inputCustom" placeholder="Email" as={Input}/>
                      <Field id="password" name="password" className="inputCustom" placeholder="Senha" as={Input}/>
                      <Field id="passwordConfirmed" name="passwordConfirmed" className="inputCustom" placeholder="Confirmar Senha" as={Input}/>
                    </fieldset>
                    <fieldset>
                      <Legend>Acesso</Legend>
                      <Field id="status" name="status" as={Select}>
                          <option value={numForActive}>Ativo</option>
                          <option value={numForInactive}>Inativo</option>
                      </Field>

                      <Field id="group" name="group" as={Select}>
                          { groupOptionsDefiner() }
                      </Field>

                      <Field 
                        id="seller" 
                        name="seller" 
                        disabled={establishmentType === 1} 
                        as={Select}
                      >
                        {branchsOptionsDefiner()}
                      </Field>
                    </fieldset>
                    {
                      errorOnSubmit && (
                        <ErrorMessage>
                          Erro ao editar usuário
                        </ErrorMessage>
                      )
                    }
                    <Button
                      type="submit"
                      className="buttonCustom"
                    >
                      Editar
                    </Button>
                  </Form>
                )
              }}
            </Formik>
          </SideForm>
        </SideContainerAnimated>
      </Row>
    </Container>
  )
}

export default General;